import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ContactFilterTopbar from '../filters/contact_filter_topbar';

import { retrievePeople } from "../store/actions/search";

export class PeopleFilterTopbar extends React.Component {
  static propTypes = {
    pageData: PropTypes.object.isRequired,
    peopleCount: PropTypes.number,
    peopleGroups: PropTypes.array.isRequired,
    retrievePeople: PropTypes.func.isRequired,
    selectedPeopleGroupIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    totalUngroupedPeopleCount: PropTypes.number.isRequired,
  };

  findSelectedGroups(selectedGroupIds, groups, ungroupedCount) {
    if (selectedGroupIds[0] === 'ungrouped') {
      return [{ id: 'ungrouped', name: 'Ungrouped', count: ungroupedCount }];
    } else {
      return groups.filter(group => selectedGroupIds.includes(group.id));
    }
  }

  render() {
    const {
      pageData,
      peopleCount,
      peopleGroups,
      retrievePeople,
      selectedPeopleGroupIds,
      totalUngroupedPeopleCount
    } = this.props;

    let selectedGroups = [];
    if (peopleGroups && peopleGroups.length > 0) {
      selectedGroups = this.findSelectedGroups(
        selectedPeopleGroupIds,
        peopleGroups,
        totalUngroupedPeopleCount
      );
    }

    let selectedGroupCount;
    if (selectedGroups.length === 0) {
      selectedGroupCount = peopleCount;
    } else if (selectedGroups[0].id === 'ungrouped') {
      selectedGroupCount = totalUngroupedPeopleCount;
    } else {
      selectedGroupCount = selectedGroups.reduce((count, group) => count + group.personCount, 0);
    }

    return (
      <ContactFilterTopbar
        contactCount={peopleCount}
        groups={peopleGroups}
        pageData={pageData}
        retrieveRecords={retrievePeople}
        selectedGroupCount={selectedGroupCount}
        selectedGroups={selectedGroups}
      />
    );
  }
}

const mapStateToProps = state => ({
  peopleCount: state.search.meta.people.databaseCount,
  peopleGroups: state.people.groups,
  selectedPeopleGroupIds: state.query.peopleGroupIds,
  totalUngroupedPeopleCount: state.search.meta.people.totalUngroupedCount
});

const mapDispatchToProps = {
  retrievePeople
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleFilterTopbar);
